import { H1, H2, Image } from "@itpi/react-components";
import React, { useContext, useEffect } from "react";
import ReactGA from "react-ga";
import { useLocation } from "react-use";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";
import luLogo from "../assets/lu-mono.png";

const Header: React.FC<{}> = () => {
  const location = useLocation();

  const { token, login } = useContext(AuthContext);
  useEffect(() => {
    ReactGA.send(["pageview", location.pathname]);
  }, [location]);

  return (
    <>
      <div
        style={{
          backgroundColor: "#b5121b",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "left",

          paddingTop: 10,
          paddingLeft: 20,
          paddingRight: 10,
          paddingBottom: 10,
        }}
      >
        <Image style={{ maxWidth: "20%", paddingRight: "20px", borderRight: "2px solid white" }} src={luLogo} alt="Lancaster University logo" />
        <div style={{ paddingLeft: 20 }}>
          <Link to={"/"} style={{ textDecoration: "none" }}>
            <H1
              style={{
                fontFamily: "EffraLight",
                color: "white",
                fontSize: "3rem",
              }}
            >
              EntreComp
            </H1>
          </Link>
          <H2
            style={{
              color: "#fff",
              fontFamily: "AktivGroteskLight",
              fontSize: 16,
              marginTop: "-1rem",
            }}
          >
            The entrepreneurship self assessment tool
          </H2>
        </div>
        {!token || token === null || token === undefined ? (
          <button
            onClick={() => login()}
            style={{
              borderRadius: 50,
              padding: 15,
              color: "black",
              backgroundColor: "#06d19c",
              border: "none",
              opacity: 1,
              marginLeft: "auto"
            }}
          >
            Log In
          </button>
        ) : null}
      </div>
    </>
  );
};

export default Header;
